/**
 * Firebase Service — Whapaxx Gaming Website (read-only, public data)
 * Uses Firebase v9 modular SDK
 * Same project config as the customer app (wpxg-33e67)
 */
import { initializeApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';
import {
  initializeFirestore,
  collection,
  doc,
  getDoc,
  getDocFromCache,
  getDocFromServer,
  getDocs,
  addDoc,
  query,
  where,
  orderBy,
  onSnapshot,
  serverTimestamp,
} from 'firebase/firestore';

// ---------- Firebase Config ----------
const firebaseConfig = {
  apiKey: 'AIzaSyCX5lPeACYg6JXFv6m2tEIaEyShO5p45Qc',
  authDomain: 'wpxg-33e67.firebaseapp.com',
  projectId: 'wpxg-33e67',
  storageBucket: 'wpxg-33e67.appspot.com',
  messagingSenderId: '824752033941',
  appId: '1:824752033941:web:77c75433f4e2d7cd280b9c',
  measurementId: 'G-4MEMP13CDV',
};

// ---------- Initialize ----------
const app = initializeApp(firebaseConfig);
const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});

const functions = getFunctions(app);

// ---------- Exports ----------
export {
  db,
  functions,
  httpsCallable,
  collection,
  doc,
  getDoc,
  getDocFromCache,
  getDocFromServer,
  getDocs,
  addDoc,
  query,
  where,
  orderBy,
  onSnapshot,
  serverTimestamp,
};
